var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.headers)?_c('v-data-table',{staticClass:"table",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":20},scopedSlots:_vm._u([{key:"item.timestamp",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moment")(item.timestamp,"DD.MM.YYYY hh:mm"))+" ")]}},{key:"item.question",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.question)+" ")]}},{key:"item.agree",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.agree ? "YES" : "NO")+" ")]}}],null,false,1712351451)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }